export function getElapsedTime(progressFraction: number, totalSeconds: number) {
  const elapsedSeconds = getElapsedSeconds(progressFraction, totalSeconds);
  return formatDuration(elapsedSeconds);
}

export function formatDuration(seconds: number) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}:${pad(mm)}:${ss}`;
  }
  return `${mm}:${ss}`;
}

function pad(value: number) {
  return ('0' + value).slice(-2);
}

export function getElapsedSeconds(progressFraction: number, totalSeconds: number) {
  return Math.round(progressFraction * totalSeconds);
}
